export default "__VITE_ASSET__ByiFGRhE__"